import axios from '@/libs/api.request'

export const login = ({ email, password }) => {
  const data = {
    email,
    password
  }
  return axios.request({
    url: '/v1/api/user/login',
    data,
    method: 'post'
  })
}

export const signup = (data) => {
  return axios.request({
    url: '/v1/api/user/signup',
    data,
    method: 'post'
  })
}

export const getUserInfo = (token) => {
  return axios.request({
    url: '/v1/api/user/info',
    method: 'get'
  })
}

export const repassword = ({ oldPassword, password }) => {
  const data = {
    oldPassword,
    password
  }
  return axios.request({
    url: '/v1/api/user/repassword',
    data,
    method: 'post'
  })
}
export const logout = (token) => {
  return axios.request({
    url: 'logout',
    method: 'post'
  })
}

export const getUnreadCount = () => {
  return axios.request({
    url: 'message/count',
    method: 'get'
  })
}

export const getMessage = () => {
  return axios.request({
    url: 'message/init',
    method: 'get'
  })
}

export const getContentByMsgId = msg_id => {
  return axios.request({
    url: 'message/content',
    method: 'get',
    params: {
      msg_id
    }
  })
}

export const hasRead = msg_id => {
  return axios.request({
    url: 'message/has_read',
    method: 'post',
    data: {
      msg_id
    }
  })
}

export const removeReaded = msg_id => {
  return axios.request({
    url: 'message/remove_readed',
    method: 'post',
    data: {
      msg_id
    }
  })
}

export const restoreTrash = msg_id => {
  return axios.request({
    url: 'message/restore',
    method: 'post',
    data: {
      msg_id
    }
  })
}

export const fetchUsers = () => {
  return axios.request({
    url: '/v1/api/users',
    method: 'get'
  })
}

export const fetchUser = () => {
  return axios.request({
    url: '/v1/api/user/' + id,
    method: 'get'
  })
}

export const editUser = (data) => {
  return axios.request({
    url: '/v1/api/users/' + data._id,
    data,
    method: 'put'
  })
}

export const addUser = (data) => {
  return axios.request({
    url: '/v1/api/users',
    data,
    method: 'post'
  })
}

export const delUser = (id) => {
  return axios.request({
    url: '/v1/api/users/' + id,
    method: 'delete'
  })
}

export const sendCode = (data) => {
  return axios.request({
    url: '/v1/api/email/code',
    data,
    method: 'post'
  })
}

export const resetPassword = (data) => {
  return axios.request({
    url: '/v1/api/user/reset-password',
    data,
    method: 'post'
  })
}
